export default function IconPlayFilled({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M22 12L7 20.6603L7 3.33974L22 12Z"
        fill="currentColor"
      />
    </svg>
  );
}
